import type { FactCheck } from "@/types/news";
import { verdictMeta } from "@/utils/news";

export default function FactCheckList({ items }: { items: FactCheck[] }) {
  return (
    <div className="mt-6 space-y-4">
      {items.map((item) => {
        const verdict = verdictMeta(item.verdict);
        return (
          <article
            key={item.claim}
            className="rounded-lg border border-background-200 bg-background-50 p-5"
          >
            <div className="flex flex-wrap items-start justify-between gap-3">
              <h4 className="flex items-start gap-2.5 font-heading text-base font-semibold text-foreground-950">
                <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-background-200 text-xs font-bold text-foreground-700">
                  Q
                </span>
                {item.claim}
              </h4>
              <span className={`inline-flex shrink-0 items-center gap-1 rounded-full px-3 py-1 text-xs font-medium ${verdict.className}`}>
                <i className={`${verdict.icon} text-sm`} aria-hidden="true"></i>
                核查结论：{verdict.label}
              </span>
            </div>
            <p className="mt-3 pl-9 text-sm leading-relaxed text-foreground-600">{item.detail}</p>
          </article>
        );
      })}
    </div>
  );
}